import { Container, Grid, TextField, Button, MenuItem, Alert, CircularProgress } from "@mui/material";
import React, { useState } from "react";

const INTERESTS = [
  { value: "osp", label: "OSP Engineering" },
  { value: "hld", label: "High-Level Design" },
  { value: "lld", label: "Low-Level Design" },
  { value: "permitting", label: "Permitting" },
  { value: "gis", label: "GIS Services" },
  { value: "cad", label: "CAD Services" },
  { value: "field", label: "Field Survey" },
  { value: "other", label: "General Inquiry" },
];

const COMPANY_TYPES = [
  { value: "isp", label: "Internet Service Provider" },
  { value: "coop", label: "Electric Cooperative" },
  { value: "municipal", label: "Municipal / Government" },
  { value: "telecom", label: "Telecom Provider" },
  { value: "contractor", label: "Contractor" },
  { value: "other", label: "Other" },
];

const ContactForm = () => {
  const [form, setForm] = useState({
    firstName: "", lastName: "", email: "", phone: "",
    company: "", interest: "", companyType: "", message: ""
  });
  const [status, setStatus] = useState({ loading: false, success: false, error: null });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) {
        setStatus({ loading: false, success: true, error: null });
        setForm({ firstName: "", lastName: "", email: "", phone: "", company: "", interest: "", companyType: "", message: "" });
      } else {
        setStatus({ loading: false, success: false, error: data.error || "Something went wrong" });
      }
    } catch (err) {
      setStatus({ loading: false, success: false, error: "Network error. Please try again." });
    }
  };

  const inputStyle = {
    mb: 2,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      "& fieldset": { borderColor: "#ccc" },
      "&:hover fieldset": { borderColor: "#999" },
      "&.Mui-focused fieldset": { borderColor: "#0F51E4" },
    },
    "& .MuiInputLabel-root": { color: "#666" },
    "& .MuiOutlinedInput-input": { color: "#333" },
    "& .MuiSelect-icon": { color: "#666" },
  };

  if (status.success) {
    return (
      <Container sx={{ mt: 3, mb: 3 }}>
        <Alert severity="success">
          Thanks for reaching out! We'll be in touch soon.
        </Alert>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 2 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="First Name *" name="firstName" value={form.firstName} onChange={handleChange} required sx={inputStyle} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Last Name *" name="lastName" value={form.lastName} onChange={handleChange} required sx={inputStyle} />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Email *" name="email" type="email" value={form.email} onChange={handleChange} required sx={inputStyle} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Phone" name="phone" value={form.phone} onChange={handleChange} sx={inputStyle} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label="Company" name="company" value={form.company} onChange={handleChange} sx={inputStyle} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth select label="I'm interested in..." name="interest" value={form.interest} onChange={handleChange} sx={inputStyle}>
              {INTERESTS.map((opt) => <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth select label="Company Type" name="companyType" value={form.companyType} onChange={handleChange} sx={inputStyle}>
              {COMPANY_TYPES.map((opt) => <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth multiline rows={4} label="Message" name="message" value={form.message} onChange={handleChange} sx={inputStyle} />
          </Grid>
          <Grid item xs={12}>
            {status.error && <Alert severity="error" sx={{ mb: 2 }}>{status.error}</Alert>}
            <Button type="submit" variant="contained" fullWidth disabled={status.loading}
              sx={{ py: 1.5, backgroundColor: "#0F51E4", "&:hover": { backgroundColor: "#0d47d1" }, fontWeight: 600, fontSize: "1rem" }}>
              {status.loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Send Message"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default ContactForm;
